/**
 * Полный перечень кодов ошибок API.
 *
 * Код, которого здесь нет, в API не возвращается: клиент ветвится по коду,
 * а не по тексту — текст меняется, код это контракт.
 *
 * Источник: docs/03-техника/архитектура.md
 */
export const ErrorCode = {
    // Авторизация и платформа
    INVALID_INIT_DATA: 'INVALID_INIT_DATA',
    CLOSED_ACCESS_REQUIRED: 'CLOSED_ACCESS_REQUIRED',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    RATE_LIMITED: 'RATE_LIMITED',
    VERSION_TOO_OLD: 'VERSION_TOO_OLD',
    INTERNAL: 'INTERNAL',
    INVALID_REQUEST: 'INVALID_REQUEST',
    INVALID_CONTENT_TYPE: 'INVALID_CONTENT_TYPE',
    INVALID_IDEMPOTENCY_KEY: 'INVALID_IDEMPOTENCY_KEY',
    IDEMPOTENCY_CONFLICT: 'IDEMPOTENCY_CONFLICT',
    // Валюты
    INSUFFICIENT_GEMS: 'INSUFFICIENT_GEMS',
    INSUFFICIENT_COINS: 'INSUFFICIENT_COINS',
    INSUFFICIENT_TICKETS: 'INSUFFICIENT_TICKETS',
    TICKET_TYPE_MISMATCH: 'TICKET_TYPE_MISMATCH',
    NEGATIVE_BALANCE: 'NEGATIVE_BALANCE',
    // Создание гильдии
    GUILD_ALREADY_EXISTS: 'GUILD_ALREADY_EXISTS',
    NAME_TOO_SHORT: 'NAME_TOO_SHORT',
    NAME_TOO_LONG: 'NAME_TOO_LONG',
    NAME_FORBIDDEN: 'NAME_FORBIDDEN',
    /** «Имя#номер» уже принадлежит другой гильдии. */
    NAME_TAKEN: 'NAME_TAKEN',
    /** Номер не из четырёх цифр 0001–9999. */
    DISCRIMINATOR_INVALID: 'DISCRIMINATOR_INVALID',
    LOGO_INVALID: 'LOGO_INVALID',
    FRAME_UNAVAILABLE: 'FRAME_UNAVAILABLE',
    FRAME_NOT_OWNED: 'FRAME_NOT_OWNED',
    // Магазин и платежи
    PRODUCT_UNAVAILABLE: 'PRODUCT_UNAVAILABLE',
    PAYMENT_ALREADY_PROCESSED: 'PAYMENT_ALREADY_PROCESSED',
    EXCHANGE_RATE_CHANGED: 'EXCHANGE_RATE_CHANGED',
    PREMIUM_STACK_LIMIT: 'PREMIUM_STACK_LIMIT',
    // Профиль
    PROFILE_HIDDEN: 'PROFILE_HIDDEN',
    SHOWCASE_LIMIT: 'SHOWCASE_LIMIT',
    BANNER_NOT_OWNED: 'BANNER_NOT_OWNED',
    MAIL_EXPIRED: 'MAIL_EXPIRED',
    MAIL_ALREADY_CLAIMED: 'MAIL_ALREADY_CLAIMED',
};
export function ok(value) {
    return { ok: true, value };
}
export function err(error) {
    return { ok: false, error };
}
export function appError(code, message, details) {
    return details === undefined ? { code, message } : { code, message, details };
}
//# sourceMappingURL=errors.js.map